<div class="certificado-modal" [ngClass]="{ 'certificado-modal--pdf': isPdf }">

  <div class="certificado-modal__header">
    <div *ngIf="isPdf" class="certificado-modal__headerLogo" aria-hidden="true" [innerHTML]="logoSvg"></div>
    <h2 class="certificado-modal__headerTitle">Certificado de venta</h2>
    <p class="certificado-modal__headerContract">Contrato: <strong>{{ detail.contract }}</strong></p>
  </div>

  <div class="certificado-modal__grid">
    <div class="certificado-modal__gridItem">
      <h3 class="certificado-modal__gridTitle">Información del cliente</h3>
      <div class="certificado-modal__gridInfo">
        <ul>
          <li>
            <h4>{{ isPdf ? 'N° de identidad' : 'N° de identificación' }}</h4>
            <p>{{ detail.customerIdentity }}</p>
          </li>
          <li>
            <h4>{{ isPdf ? 'Nombre completo' : 'Nombre del cliente' }}</h4>
            <p>{{ detail.customerName }}</p>
          </li>
        </ul>
      </div>
    </div>

    <div class="certificado-modal__gridItem">
      <h3 class="certificado-modal__gridTitle">Producto financiado</h3>
      <div class="certificado-modal__gridInfo">
        <ul>
          <li>
            <h4>Descripción</h4>
            <p>{{ detail.productDescription }}</p>
          </li>
          <li>
            <h4>IMEI</h4>
            <p>{{ detail.imei }}</p>
          </li>
          <li>
            <h4>Convenio</h4>
            <p>{{ detail.agreement }}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="certificado-modal__card">
    <h3 class="certificado-modal__cardLabel">Valor total del equipo</h3>
    <span class="certificado-modal__cardAmount">{{ detail.totalValue }}</span>
    <div class="certificado-modal__cardDetails">
      <ul>
        <li>
          <h4>Valor financiado KrediYA</h4>
          <p>{{ detail.financedAmount }}</p>
        </li>
        <li>
          <h4>Anticipo pagado al asesor</h4>
          <p>{{ detail.advance }}</p>
        </li>
      </ul>
    </div>
  </div>

  <div class="certificado-modal__grid">
    <div class="certificado-modal__gridItem">
      <h3 class="certificado-modal__gridTitle">Condiciones del crédito</h3>
      <div class="certificado-modal__gridConditions">
        <div class="certificado-modal__gridConditionsItem">
          <h4>Cuotas</h4>
          <span>{{ detail.installments }}</span>
        </div>
        <div class="certificado-modal__gridConditionsItem">
          <h4>Valor cuota</h4>
          <span>{{ detail.installmentValue }}</span>
        </div>
        <div class="certificado-modal__gridConditionsItem">
          <h4>Primera cuota</h4>
          <span>{{ detail.firstInstallmentDate }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="certificado-modal__grid">
    <div class="certificado-modal__gridItem">
      <h3 class="certificado-modal__gridTitle">Estado del crédito</h3>
      <div class="certificado-modal__gridInfo">
        <div class="status-tag" [ngClass]="getStatusSeverityClass(detail.creditStatusSeverity)">
          <span>{{ detail.creditStatus }}</span>
        </div>
      </div>
    </div>

    <div class="certificado-modal__gridItem">
      <h3 class="certificado-modal__gridTitle">Trazabilidad</h3>
      <div class="certificado-modal__gridInfo">
        <ul>
          <li>
            <h4>Solicitud</h4>
            <p>{{ detail.requestDate }}</p>
          </li>
          <li>
            <h4>Últ. actualización</h4>
            <p>{{ detail.lastUpdated }}</p>
          </li>
          <li>
            <h4>Asesor de venta</h4>
            <p>{{ detail.salesAdvisor }}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="certificado-modal__messageBox" [ngClass]="getAllyPaymentMessageClass(detail.allyPaymentSeverity)">
    <div class="certificado-modal__messageBoxTitle">
      <i [class]="getAllyPaymentIcon(detail.allyPaymentSeverity)"></i>
      <h4>{{ detail.allyPaymentTitle }}</h4>
    </div>
    <div class="certificado-modal__messageBoxDescription">
      <p>{{ detail.allyPaymentMessage }}</p>
    </div>
  </div>

  <div *ngIf="isPdf" class="certificado-modal__generated">
    <i>
      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
        <path d="M1.875 2.34534V0.470339C1.875 0.209746 2.08475 0 2.34534 0C2.60593 0 2.81568 0.209746 2.81568 0.470339V2.34534C2.81568 2.60593 2.60593 2.81568 2.34534 2.81568C2.08475 2.80932 1.875 2.60593 1.875 2.34534ZM9.84534 2.81568C10.1059 2.81568 10.3157 2.60593 10.3157 2.34534V0.470339C10.3157 0.209746 10.1059 0 9.84534 0C9.58474 0 9.375 0.209746 9.375 0.470339V2.34534C9.375 2.60593 9.58474 2.81568 9.84534 2.81568ZM15 11.25C15 13.322 13.322 15 11.25 15C9.17797 15 7.5 13.322 7.5 11.25C7.5 9.17797 9.17797 7.5 11.25 7.5C13.322 7.5 15 9.17797 15 11.25ZM14.0657 11.25C14.0657 9.69915 12.8072 8.43432 11.25 8.43432C9.69915 8.43432 8.44068 9.69915 8.44068 11.25C8.44068 12.8008 9.69915 14.0657 11.25 14.0657C12.8008 14.0657 14.0657 12.8008 14.0657 11.25ZM3.75 5.625H1.875V7.5H3.75V5.625ZM1.875 10.3157H3.75V8.44068H1.875V10.3157ZM4.69068 7.5H6.56568V5.625H4.69068V7.5ZM4.69068 10.3157H6.56568V8.44068H4.69068V10.3157ZM0.940678 11.1547V4.69068H11.25V6.56568H12.1907V2.90466C12.1907 2.33263 11.7331 1.875 11.1737 1.875H10.786V2.34534C10.786 2.86017 10.3665 3.28602 9.84534 3.28602C9.33051 3.28602 8.90466 2.86653 8.90466 2.34534V1.875H3.27966V2.34534C3.27966 2.86017 2.86017 3.28602 2.33898 3.28602C1.8178 3.28602 1.40466 2.86017 1.40466 2.34534V1.875H1.01695C0.457627 1.875 0 2.33263 0 2.90466V11.1547C0 11.7203 0.457627 12.1843 1.01695 12.1843H6.56568V11.25H1.01695C0.972458 11.25 0.940678 11.2055 0.940678 11.1547ZM9.375 7.5V5.625H7.5V7.5H9.375ZM12.6547 11.25H11.25V9.84534C11.25 9.58474 11.0403 9.375 10.7797 9.375C10.5191 9.375 10.3093 9.58474 10.3093 9.84534V11.7203C10.3093 11.9809 10.5191 12.1907 10.7797 12.1907H12.6547C12.9153 12.1907 13.125 11.9809 13.125 11.7203C13.125 11.4597 12.9153 11.25 12.6547 11.25Z" fill="black"/>
      </svg>
    </i>
    <p>Documento generado el: <strong>{{ detail.generatedAt }}</strong></p>
  </div>

  <div class="certificado-modal__disclaimer">
    <p>
      Este certificado es generado por <strong>KrediYA LATAM</strong> como soporte de la operación de crédito.
      <br>
      No reemplaza el contrato de crédito firmado por el cliente.
    </p>
  </div>

  <div class="certificado-modal__actions" *ngIf="showActions">
    <button pButton pRipple type="button" label="Cerrar" class="p-button-secondary p-button-raised p-button-rounded n-background n-shadow" (click)="onClose()"></button>
    <button pButton pRipple type="button" icon="pi pi-download" [label]="isGeneratingPdf ? 'Generando PDF...' : 'Descargar PDF'" [loading]="isGeneratingPdf" [disabled]="isLoadingCertificateDetail || isGeneratingPdf" class="p-button-primary p-button-raised p-button-rounded n-background n-shadow" (click)="onExportPdf()"></button>
  </div>
</div>
